export default __webpack_public_path__ + "07d6963d455aeee8c7ed80e81d6555d5.png";